import React, { useState, useEffect } from 'react';
import { getToken } from './auth';

function TestAPI() {
  const [data, setData] = useState('');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/`)
      .then(response => response.text()) 
      .then(text => setData(text))
      .catch(error => console.error('Failed to fetch data:', error));
  }, []);

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    minHeight: '100vh', 
    paddingTop: '60px', 
    textAlign: 'center', 
  };

  return (
    <div style={containerStyle}>
      {data ? <p>{data}</p> : <p>Server is running.</p>}
    </div>
  );
}

export default TestAPI;

export const fetchRecommendations = async (excludedIndices = []) => {
  const token = getToken();
  try {
    const query = excludedIndices.length > 0 ? `?exclude=${excludedIndices.join(',')}` : '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/recommendations${query}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching recommendations:', error);
  }
};


export const fetchItemDetails = async (itemId) => {
  try {
    const storedItems = localStorage.getItem('conferenceItems');
    if (!storedItems) {
      throw new Error('No conference items found in local storage.');
    }
    const conferenceItems = JSON.parse(storedItems);
    const itemDetails = conferenceItems.find(item => item.id.toString() === itemId.toString());
    if (!itemDetails) {
      throw new Error('Item not found.');
    }
    return itemDetails;
  } catch (error) {
    console.error('Error fetching item details:', error);
  }
};


export const likeItem = async (itemId) => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/like_item/${itemId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to like item.');
    }
    return response.json();
  } catch (error) {
    console.error('Error liking item:', error);
  }
};

export const likeItemOutside = async (itemId) => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/like_item_outside/${itemId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to like item.');
    }
    return response.json();
  } catch (error) {
    console.error('Error liking item:', error);
  }
};

export const dislikeItem = async (itemId) => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/dislike_item/${itemId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to dislike item.');
    }
    return response.json();
  } catch (error) {
    console.error('Error disliking item:', error);
  }
};

export const removeFromAgenda = async (itemId) => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/remove_from_agenda/${itemId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to remove item from agenda.');
    }
    return response.json();
  } catch (error) {
    console.error('Error removing item from agenda:', error);
  }
};

export const fetchUserAgenda = async () => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/get_agenda`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch agenda.');
    }
    const agenda = await response.json()
    return agenda.liked_item_ids;
  } catch (error) {
    console.error('Error fetching user agenda:', error);
  }
};

export const voteForPaper = async (paperId) => {
  const token = getToken();
  try {
    // Include paperId as a query parameter
    const url = new URL(`${process.env.REACT_APP_BACKEND_URL}/vote_for_paper`);
    url.searchParams.append('paper_id', paperId);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(`Failed to cast vote. Server responded with ${response.status}: ${errorBody}`);
    }

    const result = await response.json();
    console.log(result.message);
    return true;
  } catch (error) {
    console.error('Error voting for paper:', error);
    return false;
  }
};



export const getRemainingVotes = async () => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/remaining_votes`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch remaining votes.');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching remaining votes:', error);
  }
};

export const getVoteTimeline = async () => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/vote_timeline`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch vote timeline.');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching vote timeline:', error);
  }
};

export const closeConferenceVotes = async () => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/close_conference_votes`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to close conference votes.');
    }
    return await response.json();
  } catch (error) {
    console.error('Error closing conference votes:', error);
  }
};

export const fetchUserProgress = async () => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/user_progress`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch user progress.');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching user progress:', error);
  }
};

export const fetchKeywords = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/keywords`, {
      method: 'GET',
    });
    if (!response.ok) {
      throw new Error('Failed to fetch keywords.');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching keywords:', error);
  }
};

export const fetchKeywordSearchResults = async (filters) => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/keyword_search`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch keyword search results.');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching keyword search results:', error);
  }
};

export const addItemToAgenda = async (itemId) => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/add_item/${itemId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to add item to agenda.');
    }
    return response.json();
  } catch (error) {
    console.error('Error adding item to agenda:', error);
  }
};

export const skipItemFromAgenda = async (itemId) => {
  const token = getToken();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/skip_item/${itemId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to skip item from agenda.');
    }
    return response.json();
  } catch (error) {
    console.error('Error skipping item from agenda:', error);
  }
};

export const fetchProgramItems = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/all_program_items`);
    if (!response.ok) {
      throw new Error('Failed to fetch program items.');
    }
    const data = await response.json();
    return data.program_items;
  } catch (error) {
    console.error('Error fetching program items:', error);
    return []
  }
};

export const fetchAllJobs = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/all_jobs`);
    if (!response.ok) {
      throw new Error('Failed to fetch jobs.');
    }
    const data = await response.json();
    return data.jobs;
  } catch (error) {
    console.error('Error fetching jobs:', error);
    return [];
  }
};

export const postJob = async (jobDetails) => {
  try {
    const token = getToken();
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/post_job`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(jobDetails),
    });
    if (!response.ok) {
      throw new Error('Failed to post job.');
    }
    const newJob = await response.json();
    return newJob;
  } catch (error) {
    console.error('Error posting job:', error);
    return null;
  }
};
